export const LOGO_FULL =
  "https://customer-assets.emergentagent.com/job_goldline-solutions/artifacts/f442r08s_Geometric%20Logo%203.png";
export const LOGO_ICON =
  "https://customer-assets.emergentagent.com/job_goldline-solutions/artifacts/q1r6t494_Geometric%20Logo%203%20Icon%20Version.png";

export const IMAGES = {
  skyline:
    "https://images.unsplash.com/photo-1768069794826-a31af289449f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxoaWdoJTIwZW5kJTIwY2l0eSUyMHNreWxpbmUlMjBibHVlJTIwZ29sZHxlbnwwfHx8fDE3ODQwNDg2NTl8MA&ixlib=rb-4.1.0&q=85",
  office:
    "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBtZWV0aW5nJTIwbHV4dXJ5fGVufDB8fHx8MTc4NDA0ODY1OXww&ixlib=rb-4.1.0&q=85",
  construction:
    "https://images.unsplash.com/photo-1656329890168-a8f3888e9d71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxwb2xpc2hlZCUyMGNvbnN0cnVjdGlvbiUyMHdvcmslMjBibHVlJTIwc2t5fGVufDB8fHx8MTc4NDA0ODY1OXww&ixlib=rb-4.1.0&q=85",
  facade:
    "https://images.unsplash.com/photo-1592623606598-a52be21b8509?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxwb2xpc2hlZCUyMGNvbnN0cnVjdGlvbiUyMHdvcmslMjBibHVlJTIwc2t5fGVufDB8fHx8MTc4NDA0ODY1OXww&ixlib=rb-4.1.0&q=85",
  handshake:
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  foundation: "/generated/foundation.png",
  pursuit: "/generated/pursuit.png",
  connection: "/generated/connection.png",
};

export const CONTACT_EMAIL = "solutions.metropolis@gmail.com";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "The Foundation",
    body: "Metropolis Solutions LLC was built on a singular belief — that the machinery of government contracting should be navigable, transparent, and profitable for the businesses that dare to enter it. We translate complexity into opportunity.",
    image: "foundation",
  },
  {
    no: "02",
    title: "The Pursuit",
    body: "From micro-purchase thresholds to multi-million dollar awards, we identify, qualify, and pursue the contracts that fit your capabilities. Our team lives inside the solicitation landscape so you can stay focused on delivery.",
    image: "pursuit",
  },
  {
    no: "03",
    title: "The Connection",
    body: "We connect ambitious businesses to the large awards and prime relationships that define industries. Where others see red tape, we see architecture — and we know how to build within it.",
    image: "connection",
  },
];
